angular.module('ihestiaGrid', ['infinite-scroll', 'ihestiaRestServicesBase', 'pasvaz.bindonce']);